<template>
    <div>
        <v-layout row wrap xs12 class="text-xs-left teal--text text--darken-2" pl-2 pb-2>
            {{$storeCandidature.langueFormulaire == 'en' ? 'Please choose the courses you would like to integrate, in order of preference' : 'Veuillez choisir les formations que vous souhaiteriez intégrer, par ordre de préférence'}}
        </v-layout>
        <v-layout>
            <v-flex xs8>
                <v-autocomplete class="pt-0" :items="$storeCandidature.filtreProgrammeListes.SessionsList"
                                v-model="$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire"
                                :label="$storeCandidature.langueFormulaire == 'en' ? 'Speciality' : 'Spécialité'"
                                item-text="Programme.Specialite"
                                item-value="Id"
                                return-object
                                chips
                                deletable-chips
                                :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                @change="m2Changed()">
                </v-autocomplete>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs8>
                <v-autocomplete class="pt-0" :items="listeSessionM2_2"
                                v-model="$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage2"
                                :label="$storeCandidature.langueFormulaire == 'en' ? 'Second choice' : 'Choix 2'"
                                item-text="Programme.Specialite"
                                item-value="Id"
                                @change="m2_2Changed()"
                                return-object
                                chips
                                deletable-chips>
                </v-autocomplete>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs8>
                <v-autocomplete class="pt-0" :items="listeSessionM2_3"
                                v-model="$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage3"
                                :label="$storeCandidature.langueFormulaire == 'en' ? 'Third choice' : 'Choix 3'"
                                item-text="Programme.Specialite"
                                item-value="Id"
                                @change="$storeCandidature.candidatureChanged = true"
                                return-object
                                chips
                                deletable-chips>
                </v-autocomplete>
            </v-flex>
        </v-layout>
        <v-layout v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission
                  && ($storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission.Id == $storeCandidature.configurationClient.DataIdNiveauAdmissionMsc1erAnnee
                  || $storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission.Id == $storeCandidature.configurationClient.Niveau4emeAnnee)
                  && ($storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire && listeSessionM1.length != 1))">
            <v-flex xs8>
                <v-autocomplete class="pt-0" :items="listeSessionM1"
                                v-model="$storeCandidature.sasCandidature.ChoixProgramme.SessionFormulaire"
                                :label="$storeCandidature.langueFormulaire == 'en' ? 'Speciality year 1' : 'Spécialité M1'"
                                item-text="SessionM1.Programme.Specialite"
                                item-value="Id"
                                :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                @change="$storeCandidature.candidatureChanged = true"
                                return-object
                                chips
                                deletable-chips>
                </v-autocomplete>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature
            };
        },

        computed: {

            // Liste des Master2
            listeSessionM2_2() {
                if (this.$storeCandidature.filtreProgrammeListes.SessionsList && this.$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire) {
                    return this.$storeCandidature.filtreProgrammeListes.SessionsList.filter(
                        s => s.Id != this.$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire.Id)
                }
                else {
                    return []
                }
            },
            // Liste des Mastyer2 2
            listeSessionM2_3() {
                if (this.listeSessionM2_2 && this.$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage2) {
                    return this.listeSessionM2_2.filter(
                        s => s.Id != this.$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage2.Id)
                }
                else {
                    return []
                }
            },

            // Retourner la liste des sessions m1 de la sessionM2 sélectionnée
            listeSessionM1() {
                if (this.$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire) {
                    return this.$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire.ListeSessionsM1
                }
                else {
                    return []
                }
            },
        },

        methods: {
            onUpdate() {
                this.$storeCandidature.candidatureChanged = true;
                this.$emit('Valide')
            },

            m2Changed() {
                // Affecter a valeur du programme pour l'envoie des tags
                this.$storeCandidature.sasCandidature.ChoixProgramme.NomProgramme = this.$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire ? this.$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire.Programme : null

                // Si on a une sule valeur dans la lisre session M1, on la sélectionne par défaut
                if (this.listeSessionM1.length == 1) {
                    this.$storeCandidature.sasCandidature.ChoixProgramme.SessionFormulaire = this.listeSessionM1[0]
                }
                else {
                    this.$storeCandidature.sasCandidature.ChoixProgramme.SessionFormulaire = null
                }

                this.$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage2 = null
                this.$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage3 = null
                this.$storeCandidature.candidatureChanged = true
                this.onUpdate()
            },

            m2_2Changed() {
                this.$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage3 = null
                this.$storeCandidature.candidatureChanged = true
                this.onUpdate()
            },

            // Vérifie si les datas sont correctement alimenté à l'étape mounted du lifecycle du composant.
            verifDataOnMounted() {
                // Si on a une sule valeur dans la lisre session M1, on la sélectionne par défaut
                if (this.listeSessionM1 && this.listeSessionM1.length == 1) {

                    this.$storeCandidature.sasCandidature.ChoixProgramme.SessionFormulaire = this.listeSessionM1[0]
                }
            },
        },

        mounted() {
            this.verifDataOnMounted();
        },
    }
</script>

<style scoped>
</style>